import { useMemo } from 'react';

import { generateId } from '../utils/generate-id.util';

export const useIdFactory = () => useMemo(() => ({ generateId }), []);
